import React from 'react';
import { usePricing } from '../../contexts/PricingContext';
import { BriefPricingTable } from './BriefPricingTable';
import { PricingFigureRow } from './pricing/PricingFigureRow';
import { PricingTwoStep } from './pricing/PricingTwoStep';
import { PricingFeeList } from './pricing/PricingFeeList';
import { PricingTiersWithStrip } from './pricing/PricingTiersWithStrip';
interface Props {
  includeLeader: boolean;
  dueAtSigning: number;
}

/** Page 2's pricing, in whichever layout is picked in the Tailor panel. */
export function BriefPricingPanel({
  includeLeader,
  dueAtSigning
}: Props) {
  const {
    pricingLayout
  } = usePricing();
  switch (pricingLayout) {
    case 'row':
      return <PricingFigureRow includeLeader={includeLeader} data-id="element-759" data-mp="2csyjauplzhjq" />;
    case 'twoStep':
      return <PricingTwoStep includeLeader={includeLeader} dueAtSigning={dueAtSigning} data-id="element-760" data-mp="2cv1l0c04iz4a" />;
    case 'feeList':
      return <PricingFeeList includeLeader={includeLeader} data-id="element-761" data-mp="11e1u9ktfcscd" />;
    case 'tiersStrip':
      return <PricingTiersWithStrip includeLeader={includeLeader} data-id="element-762" data-mp="11byvabaanovi" />;
    default:
      return <BriefPricingTable data-id="element-763" data-mp="3i8uoo3br0tpz" />;
  }
}